import { call, put, takeEvery } from "redux-saga/effects";
import { STYLE } from "./actionTypes";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { STYLES_URL } from "../../helpers/url_api_helper";
import {
  getListaStyle,
  getStyle,
  getStyleHistory,
  getStyleHistoryList,
  saveStyle,
} from "./actions";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";
import { stringToBase64 } from "../../helpers/base64_helper";
import moment from "moment";

function* listarStyle({ payload }) {
  const filterStyle = payload;
  try {
    emptyStringToNull(filterStyle);
    const res = yield call(STYLES_URL.getStyles, filterStyle);
    yield put(getListaStyle.success(res));
  } catch (error) {
    yield put(
      getListaStyle.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's styles, please try again later"
        )
      )
    );
  }
}

function* obterStyle({ payload }) {
  const { styleId } = payload;
  try {
    const style = yield call(STYLES_URL.getStyle, styleId);
    const res = {
      ...style,
      createDate: moment(style.createDate).format("DD MMM/YY hh:mm A"),
      updateDate: style.updateDate
        ? moment(style.updateDate).format("DD MMM/YY hh:mm A")
        : "",
    };
    yield put(getStyle.success(res));
  } catch (error) {
    yield put(
      getStyle.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's style, please try again later"
        )
      )
    );
  }
}

function* salvarStyle({ payload }) {
  const { body, method } = payload;
  try {
    body.content = stringToBase64(body.content);
    if (method === "POST") {
      yield call(STYLES_URL.postStyle, body);
      yield put(saveStyle.success(true));
    } else {
      yield call(STYLES_URL.putStyle, body);
      yield put(saveStyle.success(true));
    }
  } catch (error) {
    yield put(
      saveStyle.fail(
        normalizeApiError(
          error,
          "Something went wrong saving the system style, please try again later"
        )
      )
    );
  }
}

function* listarStyleHistory({ payload }) {
  const { styleId, page } = payload;
  try {
    const res = yield call(STYLES_URL.getStyleHistoryList, styleId, page);
    yield put(getStyleHistoryList.success(res));
  } catch (error) {
    yield put(
      getStyleHistoryList.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's style, please try again later"
        )
      )
    );
  }
}

function* obterStyleHistory({ payload }) {
  const { idHistory } = payload;
  try {
    const style = yield call(STYLES_URL.getStyleHistory, idHistory);
    const res = {
      ...style,
      createDate: moment(style.createDate).format("DD MMM/YY hh:mm A"),
      updateDate: style.updateDate
        ? moment(style.updateDate).format("DD MMM/YY hh:mm A")
        : "",
    };
    yield put(getStyleHistory.success(res));
  } catch (error) {
    yield put(
      getStyleHistory.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's style, please try again later"
        )
      )
    );
  }
}

function* StyleSaga() {
  yield takeEvery(STYLE.GET_LISTA_STYLE.REQUEST, listarStyle);
  yield takeEvery(STYLE.GET_STYLE.REQUEST, obterStyle);
  yield takeEvery(STYLE.SAVE_STYLE.REQUEST, salvarStyle);
  yield takeEvery(STYLE.GET_STYLE_HISTORY_LIST.REQUEST, listarStyleHistory);
  yield takeEvery(STYLE.GET_STYLE_HISTORY.REQUEST, obterStyleHistory);
}

export default StyleSaga;
